/**
 * FeedbackBanner — Persistent home-screen banner for sharing feedback.
 *
 * Single-phase UX: one "Share feedback" button visible to all users.
 * Dismissal is in-memory only — banner reappears on every page load/refresh.
 * UI-INV-005: Leaf component — props only, no engine imports.
 */
import { useState } from "react";
import styles from "../screens/HomeScreen.module.css";
import { TEST_IDS } from "../testing/testIds";

export type FeedbackBannerProps = {
  isBeta: boolean;
  onOpenFeedback?: () => void;
};

export function FeedbackBanner({ onOpenFeedback }: FeedbackBannerProps) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const closeIcon = (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
      <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );

  return (
    <div className={styles.feedbackBanner} data-testid={TEST_IDS.HOME_FEEDBACK_BANNER}>
      <div className={styles.feedbackBannerBody}>
        <span className={styles.feedbackBannerLabel}>
          How was your retreat? We&rsquo;d love to hear.
        </span>
        <div className={styles.feedbackBannerActions}>
          <button
            className={styles.feedbackBannerBtn}
            onClick={() => onOpenFeedback?.()}
            type="button"
            data-testid={TEST_IDS.HOME_FEEDBACK_BANNER_OPEN}
          >
            Share feedback
          </button>
        </div>
      </div>
      <button
        className={styles.feedbackBannerDismiss}
        onClick={() => setDismissed(true)}
        type="button"
        aria-label="Dismiss"
        data-testid={TEST_IDS.HOME_FEEDBACK_BANNER_DISMISS}
      >
        {closeIcon}
      </button>
    </div>
  );
}
